import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'addressPipe'})
export class AddressPipe implements PipeTransform
{
  transform(street: string, postalCode: string, city: string): string
  {
    let address = '';
    if (street)
      address = street;

    if (postalCode)
    {
      if (street)
        address += ', ';
      address += postalCode + ' ';
    }
    if (city)
      address += city;

    return address;
  }
}
